import type { RouteObject } from "react-router";

import Studio from "@/pages/studio";

// AuthGuard now lives at the layout level (src/layouts/app) so every route
// mounted here shares one guard instead of wrapping each route's element.
// There is no separate /studio/preview route — the Studio canvas itself
// toggles inline between an editable draft view and a read-only rendering
// of exactly what's currently public (see StudioTopBar's draft/published
// state toggle), so there's nothing left to navigate to.
export const appRoutes: RouteObject[] = [
  {
    path: "studio",
    element: <Studio />,
  },
];
